import { CampaignType } from 'src/actions/campaigns/campaignsResource';

const voiceCSV = `timezone, phone_number, name
Africa/Abidjan, 1-555-315-6000, Jhon Smith
America/New_York, +1 555 315 5004,
America/Los_Angeles, +1 (555)315 5004,
Africa/Abidjan, 15553155114, JD
America/New_York, 1-555-315-5224, `;

const smsCSV = `timezone, phone_number, name
Africa/Abidjan, 1-555-315-6000,
America/New_York, +1 555 315 5004,
America/Los_Angeles, +1 (555)315 5004, Emma Stone
Africa/Abidjan, 15553155114,
America/New_York, 1-555-315-5224,`;

const emailCSV = `timezone,email,name
Africa/Abidjan,example1@example.com,Bob Le
America/New_York,example2@example.com,
America/Los_Angeles,example3@example.com,
Africa/Abidjan,example4@example.com,
America/New_York,example@example.com,`;

export const getCsvUri = csv => {
  return 'data:text/csv;charset=utf-8,' + encodeURI(csv);
};

export const getCsvHref = (campaignType: CampaignType) => {
  let csv;
  switch (campaignType) {
    case CampaignType.VOICE:
      csv = voiceCSV;
      break;
    case CampaignType.SMS:
      csv = smsCSV;
      break;
    case CampaignType.EMAIL:
      csv = emailCSV;
      break;
    default:
      throw new Error('invalid campaign type');
  }
  return getCsvUri(csv);
};
